var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LinkedListItem',{attrs:{"item":_vm.item}},[_c('v-list-item-title',{staticClass:"pl-3 py-2 text-wrap"},[_vm._v(_vm._s(_vm.item.title))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }